import React from 'react'
import NavBar from '../component/NavBar'

function AboutUs() {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-800 to-gray-900 text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            About Shehala Foundation
          </h1>
          <p className="text-lg md:text-2xl mb-4 opacity-90">
            Compassionate Healthcare, Orphanage, Social support for the needy
          </p>
          <div className="w-24 md:w-48 h-1 opacity-40 bg-white mx-auto mb-6 md:mb-8"></div>
          <p className="text-base md:text-lg mb-8 opacity-90 text-left md:text-center max-w-4xl mx-auto px-4">
           Shehala Foundation is a nonprofit charitable organization established in May 2011. The foundation provides free outdoor healthcare services and financial support to underprivileged communities, including Murong tribe orphans, with support from Shehala IT Limited and other generous donors. Recognizing our social responsibility toward disadvantaged communities, we initiated free outdoor healthcare clinics for the most vulnerable and helpless individuals. Our work goes beyond medical treatment — we provide care, compassion, and dignity to those in need. The foundation is also deeply committed to supporting orphans. We ensure their healthcare, nutrition, and access to primary education, helping them build a healthier and more secure future. We carry a strong vision for our philanthropic work. Although this journey began with limited resources, it marks the beginning of a long-term commitment to serving humanity. We warmly invite compassionate individuals and generous donors to connect with Shehala Foundation and support our efforts to uplift those in need. Since its inception, Shehala Foundation has provided healthcare services to over 5,500 men, women, and children, and has supported 99 orphans to date.
          </p>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Our Mission & Vision
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Our Mission
              </h3>
              <p className="text-gray-600 mb-4">
                To provide accessible, compassionate healthcare and support to underprivileged communities, ensuring that no one is denied medical care due to financial constraints. We are committed to uplifting orphans and vulnerable groups by providing healthcare, nutrition, and educational opportunities.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Our Vision
              </h3>
              <p className="text-gray-600 mb-4">
                A society where every individual has access to quality healthcare and basic necessities, regardless of their socioeconomic status. We envision a world where orphans receive the love, care, and opportunities they deserve to lead dignified lives.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Stats */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Our Impact
          </h2>
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-4xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
              <div>
                <p className="text-4xl font-bold text-gray-700">5,500+</p>
                <p className="text-gray-600">Patients Served</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-gray-700">99</p>
                <p className="text-gray-600">Orphans Supported</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-gray-700">14+</p>
                <p className="text-gray-600">Years of Service</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-gray-700">100%</p>
                <p className="text-gray-600">Free Services</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How You Can Help */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            How You Can Help
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Donate
              </h3>
              <p className="text-gray-600 mb-4">
                Your contributions help us purchase medical supplies, equipment,
                and fund our free clinic operations.
              </p>
              <a
                href="/donate"
                className="text-gray-700 font-semibold hover:text-gray-800"
              >
                Make a Donation →
              </a>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Volunteer
              </h3>
              <p className="text-gray-600 mb-4">
                Join our team of dedicated volunteers and make a difference
                in someone's life today.
              </p>
              <a
                href="/contact"
                className="text-gray-700 font-semibold hover:text-gray-800"
              >
                Become a Volunteer →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-gray-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Want to become a part of our mission?
          </h2>
          <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto">
            Don't let your geographical location or financial constraints
            prevent you from making a difference.
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-gray-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-200 transition duration-300"
          >
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="opacity-80">
            © {new Date().getFullYear()} Shehala Foundation. All rights reserved.
          </p>
          <p className="opacity-60 text-sm mt-2">
            A Compassion-Driven Approach to Corporate Social Responsibility
          </p>
        </div>
      </footer>
    </div>
  )
}

export default AboutUs
